<template>
  <v-card>
    <v-list-item
        dark
        class="pink darken-2"
    >
      <v-list-item-avatar>
        <v-icon>
          mdi-chat-alert
        </v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="title">Unanswered Messages</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-card-text class="pa-2">
      <v-list two-line>
        <v-list-item
            v-for="item in messages"
            :key="item.id"
            class="mb-1"
            :dark="isOverdue(item.timestamp)"
            :class="isOverdue(item.timestamp) ? 'pink darken-1 white--text ' : 'pink lighten-4'"
        >
          <v-list-item-content>
            <v-list-item-title
                v-text="item.body"
            />
            <v-list-item-subtitle>
              {{ item.timestamp | formatFromNow }} {{
                item.sender_full_name ? ` by
              ${item.sender_full_name}` : ''
              }}
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="item.application_number">
              <v-icon small>mdi-account-box-multiple</v-icon>
              {{ item.application_number }}
              <v-icon small>mdi-account</v-icon>
              {{ item.main_applicant }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon :to="`/applications/${item.application}`">
              <v-icon>mdi-page-next</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>

      <v-alert v-if="!messages.length" class="text-center grey--text" dense>No unanswered messages yet</v-alert>
    </v-card-text>
  </v-card>
</template>
<script>
import moment from 'moment'
import {errorNotification} from "@/components/utils";

export default {
  components: {},
  name: 'UnansweredMessages',
  data() {
    return {
      messages: []
    }
  },
  filters: {
    formatFromNow(date) {
      return moment(date).fromNow()
    },

  },
  methods: {
    fetchData() {
      this.$axios.get('/dashboard/messages/unanswered/')
          .then((response) => {
            this.messages = response.data
          })
          .catch((error) => {
            errorNotification(error)
          })
    },
    isOverdue(timestamp) {
      return moment().diff(timestamp, 'hours') > 24
    }
  },
  mounted() {
    this.fetchData()
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.v-list-item {
  border-radius: 3px !important;
}
</style>